import { createWebHistory, createRouter } from 'vue-router'

import authRoutes from '@/routes/auth.js'
import usersRoutes from '@/routes/users.js'
import librariesRoutes from '@/routes/libraries.js'
import brandsRoutes from '@/routes/brands.js'
import softwaresRoutes from '@/routes/softwares.js'
import versionsRoutes from '@/routes/versions.js'
import activitiesRoutes from '@/routes/activities.js'
import requestsRoutes from '@/routes/requests.js'
import agentsRoutes from '@/routes/agents.js'
import announcementsRoutes from '@/routes/announcements.js'
import policyExceptionsRoutes from '@/routes/policyExceptions.js'
import leakRulesRoutes from '@/routes/leakRules.js'
import filesRoutes from '@/routes/files.js'

let routes = []
routes.push(...authRoutes)
routes.push(...usersRoutes)
routes.push(...librariesRoutes)
routes.push(...brandsRoutes)
routes.push(...softwaresRoutes)
routes.push(...versionsRoutes)
routes.push(...activitiesRoutes)
routes.push(...requestsRoutes)
routes.push(...agentsRoutes)
routes.push(...announcementsRoutes)
routes.push(...policyExceptionsRoutes)
routes.push(...leakRulesRoutes)
routes.push(...filesRoutes)

routes.push({
	path: '/',
	redirect: '/auth/login'
})

const router = createRouter({
	history: createWebHistory(),
	routes,
});

export default router
